import { useTranslation } from 'react-i18next'
import { formatCurrency } from '../../../../domain/vos/format-currency'
import { CardInfoBox } from '../../../components/card-info-box'
import { LoadingCard } from '../../../components/loading-card'

type NetRevenueProps = {
  amount?: number
  isLoading: boolean
}

export const NetRevenue = ({ isLoading, amount }: NetRevenueProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <LoadingCard />
  }

  return (
    <CardInfoBox
      title={t('netRevenue.title')}
      description={t('netRevenue.description')}
      current={formatCurrency(amount ?? 0)}
    />
  )
}
